<template>
    <div class="container-print">
        <div class="print-empty-wrap"
            style="display: flex; justify-content: center; align-items: center; flex-direction: column;"
            :style="{ minHeight: emptyMinHeight }">
            <div class="print-btn">
                <i class="el-icon-printer" style="font-size: 66px;"></i>
            </div>
            <div v-if="printList.length == 0" style="margin-top: 30px;">暂无资格审核资料可下载，敬请等待!</div>
            <div v-else style="margin-top: 30px;">资格审核登记表可下载，请下载打印!</div>
        </div>
        <div v-if="printList.length > 0" class="download-title">相关下载附件</div>
        <div v-for="item in printList" :key="item.id"
            class="download-item"
            @click="handleDownload(item)">
            <i class="el-icon-folder-opened" style="font-size: 18px"></i>
            <div class="download-name">{{ item.examName }}.pdf</div>
            <div class="download-actions">
                <el-button type="text" size="mini" @click.stop="handlePreview(item)">预览</el-button>
                <el-button type="text" size="mini" @click.stop="handleDownload(item)">下载</el-button>
            </div>
        </div>
        <!-- 考生端内嵌预览：PDF 以 blob 方式交给浏览器内置阅读器渲染 -->
        <div v-if="previewUrl" class="pdf-preview">
            <div class="pdf-preview-header">
                <span>文件预览</span>
                <el-button type="text" size="mini" @click="revokePreview">关闭预览</el-button>
            </div>
            <div v-loading="previewLoading">
                <iframe :src="previewUrl" class="pdf-frame"></iframe>
            </div>
            <div class="pdf-tip">若预览为空白（部分手机浏览器不支持），请点击「下载」用本地 PDF 阅读器打开。</div>
        </div>
    </div>
</template>

<script>
import * as ExamApi from "@/api/exam/index";
export default {
    data() {
        return {
            printList: [],
            previewUrl: "",
            previewLoading: false,
            activeKey: "",
        }
    },
    computed: {
        emptyMinHeight() {
            if (this.printList.length > 0) return 'auto';
            return window.innerWidth <= 768 ? 'calc(100vh - 260px)' : 'calc(100vh - 190px)';
        }
    },
    created() {
        this.$nextTick(() => {
            this.getPrintData();
        });
    },
    methods: {
        getPrintData() {
            // 仅显示当前考试的资格审核登记表下载
            ExamApi.getQualificationReviewFormList({
                examId: this.$store.state.exam.currentExamId,
            }).then((res) => {
                this.printList = Array.isArray(res) ? res : [];
                // 默认预览第一份，考生打开页面即可看到登记表
                if (this.printList.length) {
                    this.handlePreview(this.printList[0]);
                }
            }).catch(() => {
                this.printList = [];
            });
        },
        // 下载接口统一返回 PDF 字节流，预览与下载共用同一次请求逻辑
        requestBlob(item) {
            return ExamApi.downloadQualificationReviewForm({
                examId: item.examId,
            }).then((res) => new Blob([res], { type: "application/pdf" }));
        },
        // 预览：把 PDF 转成 blob URL 交给 iframe 渲染
        async handlePreview(item) {
            if (this.activeKey === String(item.id) && this.previewUrl) return;
            this.previewLoading = true;
            try {
                const blob = await this.requestBlob(item);
                this.revokePreview();
                this.previewUrl = window.URL.createObjectURL(blob);
                this.activeKey = String(item.id);
            } catch (error) {
                console.error("预览失败:", error);
                this.$message.error("预览加载失败，请点击下载后查看");
            } finally {
                this.previewLoading = false;
            }
        },
        revokePreview() {
            if (this.previewUrl) {
                window.URL.revokeObjectURL(this.previewUrl);
                this.previewUrl = "";
                this.activeKey = "";
            }
        },
        handleDownload(item) {
            this.requestBlob(item).then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${item.examName}.pdf`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }).catch((error) => {
                console.error("下载失败:", error);
            });
        },
    },
    beforeDestroy() {
        this.revokePreview();
    },
}
</script>

<style scoped lang="scss">
.container-print {
    padding: 30px;
    width: 90%;
}

.print-btn {
    width: 88px;
    height: 88px;
    background: #f5f7fa;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.download-title {
    color: #A40000;
    font-size: 16px;
    font-weight: bold;
    margin: 100px 0 10px;
}

.download-item {
    color: #1989fa;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    cursor: pointer;
}

.download-name {
    font-size: 16px;
}

.download-actions {
    margin-left: auto;
}

.pdf-preview {
    margin-top: 20px;
}

.pdf-preview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    color: #303133;
    font-size: 16px;
    font-weight: bold;
}

.pdf-frame {
    width: 100%;
    height: 78vh;
    border: 1px solid #ebeef5;
    background: #f5f7fa;
}

.pdf-tip {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
    .container-print {
        padding: 20px 16px;
        width: 100%;
        box-sizing: border-box;
    }

    .print-btn {
        width: 72px;
        height: 72px;

        i {
            font-size: 48px !important;
        }
    }

    .download-title {
        margin: 30px 0 10px;
    }

    .download-item {
        padding: 8px 0;
        word-break: break-all;

        .download-name {
            font-size: 14px;
        }
    }

    .download-actions {
        margin-left: 0;
    }

    .pdf-frame {
        height: 60vh;
    }
}
</style>